module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (returnCode == -400001){ ;
__p += '\r\n<div class="prompt-box">\r\n    <h6 class="prompt-head">您还未登录房掌柜</h6>\r\n    <p class="prompt-text">请先登录后再重新操作</p>\r\n    <div class="btns">\r\n        <button class="see-soon">稍后再说</button>\r\n        <button class="login-now">现在登录</button>\r\n    </div>\r\n</div>\r\n';
 }else{ ;
__p += '\r\n<div class="prompt-box">\r\n    <h6 class="prompt-head">' +
((__t = ( returnMsg )) == null ? '' : __t) +
'</h6>\r\n    <button class="prompt-yes">确定</button>\r\n</div>\r\n';
 } ;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/firstPage/templates/promptBox.ejs
// module id = 298
// module chunks = 48